
import {PropType} from "vue";
import {I18nContext} from "@/context/I18nContext";
import InputImage from "@/components/UI/InputImage.vue";
import {DpModuleEnum} from "@/api/enums/dp-module-enum";

export default {
  name: "I18nInputImage",
  emits: ['imageCleared', 'previewUrlChanged'],
  computed: {
    DpModuleEnum() {
      return DpModuleEnum
    }
  },
  components: {InputImage},
  extends: InputImage,
  props: {
    languages: {
      type: Array as PropType<string[]>,
      required: false,
      default() {
        return I18nContext.getLanguages();
      }
    },
    activeLanguage: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      internalData: this.data,
    };
  },
}
